import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { findDOMNode } from "react-dom";
import { Link, withRouter } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";

import { Button, AppBar, Toolbar, IconButton, Avatar, Divider, Hidden, Popover, Grid, Typography, ButtonBase } from "@material-ui/core";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import FormControl from "@material-ui/core/FormControl";
import DialogContent from "@material-ui/core/DialogContent";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import image from "../helper/image";

// import SearchIcon from "@material-ui/icons/Search";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import MenuIcon from "@material-ui/icons/Menu";
import AddIcon from "@material-ui/icons/Add";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import EditIcon from "@material-ui/icons/Edit";
import BusinessIcon from "@material-ui/icons/Business";
import Notification from "./notifications/Notification";
import ModalContainer from "../components/modal/ModalContainer";

import logo from "../img/hotgig-app-logo.png";
import production from "../img/production.svg";
import dj from "../img/dj.svg";

import { ArtistIcon, AgentIcon, VenueIcon, PartiesIcon, SingleVenueIcon, VenueGroupIcon } from "./welcome/WelcomeIcons";

import "./Header.css";
import { ProfileType } from "../types/enum";
const SHOW_PRODUCTION_CREW = process.env.REACT_APP_SHOW_PRODUCTION_CREW === "true";
const SHOW_DJ = process.env.REACT_APP_SHOW_DJ === "true";

@inject("templateStore", "authStore", "profileStore", "billingStore", "userStore", "hgBillingStore")
@withRouter
@observer
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            anchorEl: null,
            anchorOriginVertical: "bottom",
            anchorOriginHorizontal: "right",
            transformOriginVertical: "top",
            transformOriginHorizontal: "right",
            disableUnderline: true,
            openAccountSelector: false,
            secondStep: false
        };
    }

    searchField = null;

    handleClickButton = () => {
        this.props.templateStore.setHeaderPopOverAnchor(findDOMNode(this.toolbar));
        this.props.templateStore.toggleHeaderPopover();
        
        const { currentProfileType } = this.props.profileStore;
        if (currentProfileType === ProfileType.Musician.ordinal) {
            this.props.profileStore.getUserActList();
        }
    };

    handleProfileSelection = profile => () => {
        var type = profile.type
        this.props.profileStore.setProfileType(type);
        this.props.hgBillingStore.setAccess(type);
        this.handleClose();
        this.props.profileStore.loadProfilesAfterLogin().then(() => {
            var to= profile.isConsultant?"/agent": profile.type === ProfileType.PrivateHire.ordinal ? "/privatehire/gig" :  "/" + profile.typeString
            this.props.history.push(to);

        }).finally(() => {
        })
    };

    handleClose = e => {
        this.props.templateStore.toggleHeaderPopover();
    };

    handleCloseAccountSelector = e => {
        this.setState({
            openAccountSelector: false,
            secondStep: false
        });
    };

    handleOpenAccountSelector = e => {
        this.props.templateStore.toggleHeaderPopover();
        this.setState({
            openAccountSelector: true
        });
    };

    handleSearchChange = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            this.props.history.push(`/search?query=${this.searchField.props.value}`);
        }
    };

    handleDrawerToggle = () => {
        this.props.templateStore.toggleSidebar();
    };

    handleLogoutClick = e => {
        e.preventDefault();
        this.props.authStore.logout().then(() => {
            this.props.templateStore.toggleHeaderPopover();
            this.props.history.push("/sign-in");
        });
    };

    handleBack = (e) => {
        e.preventDefault();
        this.props.history.push('/sign-in')
    }

    renderProfiles = () => {
        const { profiles, currentProfileType } = this.props.profileStore;

        if (profiles && profiles.length > 0) {
            let result = [];
            
            for (let i = 0; i < profiles.length; i++) {
                if (profiles[i].type !== currentProfileType && profiles[i].type !== 5 && profiles[i].type !== 4 /*don't show act in profile selector*/) {
                    if (
                        profiles[i].type !== ProfileType.Production.ordinal ||
                        (profiles[i].type === ProfileType.Production.ordinal && SHOW_PRODUCTION_CREW)
                    ) {
                        result.push(<Divider key={i} />); // random key to remove warning
                        
                        result.push(
                            <ListItem
                                key={i + 100}
                                // component={Link}
                                // to={profiles[i].isConsultant?"/agent": profiles[i].type === ProfileType.PrivateHire.ordinal ? "/privatehire/gig" :  "/" + profiles[i].typeString}
                                button
                                onClick={this.handleProfileSelection(profiles[i])}
                            >
                                <Avatar src={image.getProfileImage(profiles[i])} />
                                <ListItemText primary={profiles[i].isConsultant || profiles[i].type === ProfileType.PrivateHire.ordinal?profiles[i].firstName+" "+profiles[i].lastName:profiles[i].fullName} secondary={profiles[i].labelType} />
                                <ListItemSecondaryAction>
                                    <IconButton
                                        aria-label="Edit Profile"
                                        component={Link}
                                        to={profiles[i].isConsultant?"/agent/edit/new/consultant":"/" + profiles[i].typeString + "/edit"}
                                        onClick={this.handleProfileSelection(profiles[i].type)}
                                    >
                                        <SettingsIcon />
                                    </IconButton>
                                </ListItemSecondaryAction>
                            </ListItem>
                        );
                    }
                }
            }
            result.push(<Divider key={200} />);

            return result;
        }
        return null;
    };

    render() {
        const { profiles, currentProfileType, currentProfile } = this.props.profileStore;
        const { secondStep } = this.state;
        
        if(profiles==null) return "";
        let profileTypes = profiles.filter(x => x.type !== ProfileType.Act.ordinal);
        profileTypes = profileTypes.map(x => x.type); // need to map all the types

        let profile = currentProfile;
        // if (profiles && profiles.length > 0) {
        //     for (let i = 0; i < profiles.length; i++) {
        //         if (profiles[i].type === currentProfileType) {
        //             profile = profiles[i];
        //             break;
        //         }
        //     }
        // }

        // let onSearchFocus = () => {
        //     this.setState({
        //         disableUnderline: false
        //     });
        // };

        // let onSearchBlur = () => {
        //     this.setState({
        //         disableUnderline: true
        //     });
        // };

        return (
            <AppBar
                title="hotgiggity"
                ref={node => {
                    this.toolbar = node;
                }}
                style={{ background: '#262626' }}
            >
                <Toolbar className="toolbar-gutter">
                    {/* normal togler for mobile */}
                    {!this.props.hideToggler &&
                        !this.props.forceToggler &&
                        this.props.userStore.currentUser && (
                            <Hidden mdUp>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    onClick={this.handleDrawerToggle}
                                    style={{ marginRight: "-20px" }}
                                >
                                    <MenuIcon />
                                </IconButton>
                            </Hidden>
                        )}
                    {/* force togler for public profile page */}
                    {this.props.forceToggler &&
                        this.props.userStore.currentUser && (
                            <IconButton color="inherit" aria-label="open drawer" onClick={this.handleDrawerToggle} style={{ marginRight: "-20px" }}>
                                <MenuIcon />
                            </IconButton>
                        )}
                    <img src={logo} alt="hotgiggity" style={{ marginRight: "5%", maxWidth: "190px", marginLeft: "20px" }} />
                    <div style={{ flexGrow: 1 }} />
                    {this.props.userStore.currentUser ? (
                        <React.Fragment>
                            <Notification />
                            <ButtonBase
                                onClick={this.handleClickButton}
                                ref={node => {
                                    this.button = node;
                                }}
                                id="avatar-btn"
                            >
                                {profile && currentProfileType ? (
                                    <Avatar src={image.getProfileImage(profile)} />
                                ) : currentProfileType ? (
                                    <Avatar>
                                        <PersonIcon />
                                    </Avatar>
                                ) : null}
                            </ButtonBase>
                        </React.Fragment>
                    ) : (
                        <LinkContainer to="/sign-in">
                            <Button onClick={this.handleBack} className="btnSignIn" small="true" variant="text">
                                Sign In
                            </Button>
                        </LinkContainer>
                    )}
                    {/* {currentProfileType ? (
                        <IconButton
                            id="avatar-btn"
                            ref={node => {
                                this.button = node;
                            }}
                            onClick={this.handleClickButton}
                        >
                            <ExpandMoreIcon />
                        </IconButton>
                    ) : null} */}

                    <Popover
                        open={this.props.templateStore.openHeaderPopover}
                        anchorEl={this.props.templateStore.headerPopoverAnchor}
                        anchorOrigin={{
                            vertical: this.props.templateStore.headerPopoverVerticalAnchorAlign,
                            horizontal: this.props.templateStore.headerPopoverHorizontalAnchorAlign
                        }}
                        transformOrigin={{
                            vertical: this.props.templateStore.headerPopoverVerticalTransformAlign,
                            horizontal: this.props.templateStore.headerPopoverHorizontalTransformAlign
                        }}
                        onClose={this.handleClose}
                        id="header-popover"
                    >
                        <div className="profile-selector-container">
                            {/* Pink Gradient Header */}
                            <div className="avatar-nav-header">
                                {profile ? (
                                    <Avatar className="avatar-nav-header-avatar" src={image.getProfileImage(profile)} />
                                ) : (
                                    <Avatar className="avatar-nav-header-avatar">
                                        <PersonIcon style={{ width: 36, height: 36 }} />
                                    </Avatar>
                                )}
                                <div className="avatar-nav-header-info">
                                    <div className="avatar-nav-header-name">
                                        {profile
                                            ? profile.isConsultant || profile.type === ProfileType.PrivateHire.ordinal
                                                ? profile.firstName + " " + profile.lastName
                                                : profile.fullName
                                            : ""}
                                    </div>
                                    <div className="avatar-nav-header-type">
                                        {profile && profile.labelType}
                                    </div>
                                </div>
                            </div>

                            {/* Quick Actions Row */}
                            <div className="avatar-nav-quick-actions">
                                {currentProfileType !== ProfileType.Staff.ordinal && currentProfileType !== ProfileType.PrivateHire.ordinal && (
                                    <Link
                                        to={"/profile/" + (profile && profile.id)}
                                        target="_blank"
                                        onClick={this.handleClose}
                                        className="avatar-nav-quick-action"
                                        title={currentProfileType === ProfileType.Musician.ordinal ? "View & edit your personal profile" : "View your public profile"}
                                    >
                                        <PersonIcon className="avatar-nav-quick-action-icon" />
                                        <span className="avatar-nav-quick-action-label">
                                            {currentProfileType === ProfileType.Musician.ordinal ? "My Personal Profile" : "My Profile"}
                                        </span>
                                    </Link>
                                )}
                                <Link
                                    to="/account/setting"
                                    onClick={this.handleClose}
                                    className="avatar-nav-quick-action"
                                    title="Manage account settings including, email, password, membership & settings"
                                >
                                    <SettingsIcon className="avatar-nav-quick-action-icon" />
                                    <span className="avatar-nav-quick-action-label">My Account</span>
                                </Link>
                                {profile && profile.isConsultant && (
                                    <Link
                                        to="/agent"
                                        onClick={this.handleClose}
                                        className="avatar-nav-quick-action"
                                        title="View the agency you work with"
                                    >
                                        <BusinessIcon className="avatar-nav-quick-action-icon" />
                                        <span className="avatar-nav-quick-action-label">View Agency</span>
                                    </Link>
                                )}
                            </div>

                            {/* My Acts Section - Artist/Entertainer Only */}
                            {currentProfileType === ProfileType.Musician.ordinal && this.props.profileStore.actList && this.props.profileStore.actList.length > 0 && (
                                <>
                                    <div className="avatar-nav-section-header">
                                        <span className="avatar-nav-section-label">My Acts</span>
                                        <Link
                                            to="/musician/acts"
                                            onClick={this.handleClose}
                                            className="avatar-nav-section-action"
                                        >
                                            Manage All
                                        </Link>
                                    </div>
                                    <div className="avatar-nav-list">
                                        {this.props.profileStore.actList.slice(0, 3).map((act, idx) => (
                                            <div
                                                key={idx}
                                                className="avatar-nav-list-item"
                                                onClick={() => {
                                                    this.handleClose();
                                                    this.props.history.push("/profile/" + act.id);
                                                }}
                                            >
                                                <Avatar className="avatar-nav-list-item-avatar" src={image.getProfileImage(act)} />
                                                <div className="avatar-nav-list-item-info">
                                                    <div className="avatar-nav-list-item-name">{act.actName || act.fullName}</div>
                                                    <div className="avatar-nav-list-item-type">{act.actTypeName || "Act"}</div>
                                                </div>
                                                <IconButton
                                                    className="avatar-nav-list-item-action"
                                                    component={Link}
                                                    to={"/myact/edit/" + act.id + "/general"}
                                                    onClick={(e) => { e.stopPropagation(); this.handleClose(); }}
                                                    title={"Edit " + (act.actName || act.fullName)}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            {/* Switch Profiles Section */}
                            {profiles && profiles.filter(p => p.type !== currentProfileType && p.type !== ProfileType.Act.ordinal).length > 0 && (
                                <>
                                    <div className="avatar-nav-section-header">
                                        <span className="avatar-nav-section-label">Switch Profile</span>
                                    </div>
                                    <div className="avatar-nav-list">
                                        {profiles.filter(p => 
                                            p.type !== currentProfileType && 
                                            p.type !== ProfileType.Act.ordinal &&
                                            (p.type !== ProfileType.Production.ordinal || SHOW_PRODUCTION_CREW)
                                        ).map((p, idx) => (
                                            <div
                                                key={idx}
                                                className="avatar-nav-list-item"
                                                onClick={this.handleProfileSelection(p)}
                                            >
                                                <Avatar className="avatar-nav-list-item-avatar" src={image.getProfileImage(p)} />
                                                <div className="avatar-nav-list-item-info">
                                                    <div className="avatar-nav-list-item-name">
                                                        {p.isConsultant || p.type === ProfileType.PrivateHire.ordinal
                                                            ? p.firstName + " " + p.lastName
                                                            : p.fullName}
                                                    </div>
                                                    <div className="avatar-nav-list-item-type">{p.labelType}</div>
                                                </div>
                                                <IconButton
                                                    className="avatar-nav-list-item-action"
                                                    component={Link}
                                                    to={p.isConsultant ? "/agent/edit/new/consultant" : "/" + p.typeString + "/edit"}
                                                    onClick={(e) => { e.stopPropagation(); this.handleProfileSelection(p)(); }}
                                                    title="Edit profile"
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}

                            {/* Footer Actions */}
                            <div className="avatar-nav-footer">
                                <button
                                    className="avatar-nav-footer-btn add-profile"
                                    disabled={profileTypes.length >= 4}
                                    onClick={this.handleOpenAccountSelector}
                                >
                                    <AddIcon />
                                    Add Profile
                                </button>
                                <button
                                    className="avatar-nav-footer-btn sign-out"
                                    onClick={this.handleLogoutClick}
                                >
                                    <ExitToAppIcon />
                                    Sign Out
                                </button>
                            </div>
                        </div>
                    </Popover>
                </Toolbar>
                {/* <Hidden mdUp>
                    <Toolbar style={{ backgroundColor: "#ffffff" }}>
                        <FormControl className="searchInput" fullWidth>
                            <Input
                                placeholder="Search for an Act, Agent or Venue"
                                disableUnderline={this.state.disableUnderline}
                                onFocus={onSearchFocus}
                                onBlur={onSearchBlur}
                                onKeyUp={this.handleSearchChange}
                                onChange={e => this.props.templateStore.setMainSearchValue(e.target.value)}
                                ref={node => (this.searchField = node)}
                                value={this.props.templateStore.mainSearchValue}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Toolbar>
                </Hidden> */}

                <ModalContainer
                    open={this.state.openAccountSelector}
                    title={ secondStep ? "Select Venue Type" : "Add Profile"}
                    maxWidth="sm"
                    coloredDialogTitle = {true}
                    onClose={this.handleCloseAccountSelector}
                    fullScreen={false}
                >
                    <DialogContent className="add-profile-dialog-content">
                        {!secondStep && (
                            <>
                                <p className="add-profile-subtitle">
                                    Create an additional profile to expand your presence on Hot Giggity
                                </p>
                                <div className="add-profile-grid">
                                    {profileTypes.indexOf(1) < 0 && (
                                        <Link to="/musician/edit/new" className="add-profile-card">
                                            <div className="add-profile-card-icon">
                                                <ArtistIcon />
                                            </div>
                                            <div className="add-profile-card-title">Artist / Entertainer</div>
                                            <div className="add-profile-card-description">
                                                Performers, musicians, DJs, and entertainers
                                            </div>
                                        </Link>
                                    )}

                                    {profileTypes.indexOf(2) < 0 && (
                                        <Link to="/agent/edit/new" className="add-profile-card">
                                            <div className="add-profile-card-icon">
                                                <AgentIcon />
                                            </div>
                                            <div className="add-profile-card-title">Agent</div>
                                            <div className="add-profile-card-description">
                                                Manage and book talent for venues
                                            </div>
                                        </Link>
                                    )}

                                    {profileTypes.indexOf(3) < 0 && (
                                        <div
                                            className="add-profile-card"
                                            onClick={() => this.setState({ secondStep: true })}
                                        >
                                            <div className="add-profile-card-icon">
                                                <VenueIcon />
                                            </div>
                                            <div className="add-profile-card-title">Venue</div>
                                            <div className="add-profile-card-description">
                                                Pubs, clubs, restaurants, and event spaces
                                            </div>
                                        </div>
                                    )}

                                    {profileTypes.indexOf(9) < 0 && (
                                        <Link to="/privatehire/private/edit/new" className="add-profile-card">
                                            <div className="add-profile-card-icon">
                                                <PartiesIcon />
                                            </div>
                                            <div className="add-profile-card-title">Parties & Events</div>
                                            <div className="add-profile-card-description">
                                                Private event organisers and party planners
                                            </div>
                                        </Link>
                                    )}

                                    {profileTypes.indexOf(6) < 0 && SHOW_PRODUCTION_CREW && (
                                        <Link to="/production/edit" className="add-profile-card">
                                            <div className="add-profile-card-icon">
                                                <img src={production} alt="production" style={{ width: '100%', height: '100%' }} />
                                            </div>
                                            <div className="add-profile-card-title">Production</div>
                                            <div className="add-profile-card-description">
                                                Production crew and technical staff
                                            </div>
                                        </Link>
                                    )}

                                    {profileTypes.indexOf(7) < 0 && SHOW_DJ && (
                                        <Link to="/dj/edit" className="add-profile-card">
                                            <div className="add-profile-card-icon">
                                                <img src={dj} alt="dj" style={{ width: '100%', height: '100%' }} />
                                            </div>
                                            <div className="add-profile-card-title">DJ</div>
                                            <div className="add-profile-card-description">
                                                Disc jockeys and music selectors
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            </>
                        )}

                        {secondStep && (
                            <>
                                <button
                                    type="button"
                                    className="add-profile-back-link"
                                    onClick={() => this.setState({ secondStep: false })}
                                >
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M19 12H5M12 19l-7-7 7-7"/>
                                    </svg>
                                    Back to profile types
                                </button>
                                <p className="add-profile-subtitle">
                                    Choose the type of venue profile you want to create
                                </p>
                                <div className="add-profile-grid venue-type-grid">
                                    <Link to="/staff/single/edit/new" className="add-profile-card">
                                        <div className="add-profile-card-icon">
                                            <SingleVenueIcon />
                                        </div>
                                        <div className="add-profile-card-title">Single Venue</div>
                                        <div className="add-profile-card-description">
                                            One venue location
                                        </div>
                                    </Link>

                                    <Link to="/staff/group/edit/new" className="add-profile-card">
                                        <div className="add-profile-card-icon">
                                            <VenueGroupIcon />
                                        </div>
                                        <div className="add-profile-card-title">Venue Group</div>
                                        <div className="add-profile-card-description">
                                            Multiple venue locations
                                        </div>
                                    </Link>
                                </div>
                            </>
                        )}
                    </DialogContent>
                </ModalContainer>
            </AppBar>
        );
    }
}

export default Header;
